import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { Element } from '../../../common/html/element'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { selectAlertById } from '../store/slice'
import { TABLE_COL } from './constant'
import { TriggerCell } from './TriggerCell'
import { TypeDescription } from './TypeDescription'

export const TableCell = ({ data, colId, rowId, rowIndex }) => {
  const navigate = useNavigate()
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()
  const isRead = useSelector(selectAlertById(rowId, 'readStatus'))

  const onClick = () => {
    navigate(`/alerts/${rowId}`)
  }

  const renderCell = () => {
    switch (colId) {
      case TABLE_COL.STT:
        return rowIndex + 1
      case TABLE_COL.TYPE:
        return <TypeDescription rowId={rowId} />
      case TABLE_COL.DATE:
        return (
          <Element className="whiteSpaceNowrap">
            {formatDateTime(data, FORMAT.DATE, locale, timezone)}
          </Element>
        )
      case TABLE_COL.TRIGGER:
        return <TriggerCell rowId={rowId} data={data} />
      default:
        return data
    }
  }

  return (
    <Element onClick={onClick} className={isRead ? 'fw400' : 'fw600'}>
      {renderCell()}
    </Element>
  )
}
